import { message } from "ant-design-vue";

export class GlobalMessage {
    static key = "single-message";
    static error(content) {
        message.error({ content: content, key: this.key });
    }
    static success(content) {
        message.success({ content: content, key: this.key });
    }
    static info(content) {
        message.info({ content: content, key: this.key });
    }
    static warning(content) {
        message.warning({ content: content, key: this.key });
    }
    static loading(content) {
        message.loading({ content: content, key: this.key });
    }
    static destroy() {
        message.destroy(this.key);
    }
}
